import dayjs from "dayjs";

export default function formatAsMMDDYYYY(value?: string | null, includeTime = false): string {
  if (!value) {
    return "";
  }

  const parsed = dayjs(value);
  if (!parsed.isValid()) {
    return value;
  }

  return parsed.format(includeTime ? "MM-DD-YYYY h:mm A" : "MM-DD-YYYY");
}
